import { reactive, getCurrentInstance } from 'vue'
import qs from 'qs'

export default function useUserReviews() {
	const app = getCurrentInstance()
	const { $axios } = app.appContext.config.globalProperties
	const properties = reactive({
		fetchCommentsUrl: '',
		postReviewUrl: '',
		reviewsResponseKey: '',
		reviews: [],
		totalPages: 0,
		userReview: {},
		userReviewResponseKey: '',
	})

	const getModuleData = ({ module, page, page_size, id }) => {
		const data = { page_size, page }

		switch (module) {
			case 'courses':
				properties.fetchCommentsUrl = `/etraining_courses/group_training/${id}/get_group_training_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `/etraining_courses/group_training/${id}/set_group_training_user_star/`
				properties.reviewsResponseKey = 'group_training_user_stars'
				properties.userReviewResponseKey = 'group_training_user_starred'
				return
			case 'live-classes':
				properties.fetchCommentsUrl = `/etraining_live_classes/live_classes/${id}/get_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `/etraining_live_classes/live_classes/${id}/set_user_star/`
				properties.reviewsResponseKey = 'live_class_user_stars'
				properties.userReviewResponseKey = 'live_class_user_starred'
				return
			case 'presentials':
				properties.fetchCommentsUrl = `/etraining_presential/presential/${id}/get_presential_event_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `/etraining_presential/presential/${id}/set_presential_event_user_star/`
				properties.reviewsResponseKey = 'presential_event_user_stars'
				properties.userReviewResponseKey = 'presential_event_user_starred'
				return
			case 'podcasts':
				properties.fetchCommentsUrl = `etraining_podcast/podcasts/${id}/get_podcast_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `etraining_podcast/podcasts/${id}/set_podcast_user_star/`
				properties.reviewsResponseKey = 'playlist_podcast_stars'
				properties.userReviewResponseKey = 'user_starred'
				return
			case 'trails':
				properties.fetchCommentsUrl = `/etraining_trails/trails/${id}/get_trail_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `/etraining_trails/trails/${id}/set_trail_user_star/`
				properties.reviewsResponseKey = 'trail_user_stars'
				properties.userReviewResponseKey = 'trail_user_starred'
				return
			case 'webcasts':
				properties.fetchCommentsUrl = `/etraining_webcasts/webcasts/${id}/get_webcast_user_stars/?${qs.stringify(
					data
				)}`
				properties.postReviewUrl = `/etraining_webcasts/webcasts/${id}/set_webcast_user_star/`
				properties.reviewsResponseKey = 'webcast_user_stars'
				properties.userReviewResponseKey = 'webcast_user_starred'
				return
			default:
				return ''
		}
	}

	const fetchReviews = async ({ module, page, page_size, id }) => {
		getModuleData({ module, page, page_size, id })

		try {
			const response = await $axios.get(properties.fetchCommentsUrl)
			properties.totalPages =
				response.data.count !== 0 ? Math.ceil(response.data.count / page_size) : 1
			properties.reviews = response.data.results[properties.reviewsResponseKey]
				? response.data.results[properties.reviewsResponseKey].map((comment) => comment)
				: []

			if (response.data.results[properties.userReviewResponseKey]) {
				properties.userReview = response.data.results[properties.userReviewResponseKey]
			}

			return {
				totalPages: properties.totalPages,
				comments: properties.reviews,
				userReview: properties.userReview,
			}
		} catch (e) {
			console.log(e)
		}
	}

	const postReview = async ({ module, data, id }) => {
		try {
			await $axios.post(properties.postReviewUrl, data)
		} catch (e) {
			console.log(e)
		}
	}

	return { fetchReviews, postReview }
}
